import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PriorityHighIcon(props: IconProps) {
    return <Icon {...props} iconKey={"priority_high"}/>
}
